export default function printReportNotes(type, status, startDate, endDate, params) {
  const token = localStorage.getItem("token");

  console.log(params)
  printNotes(token, type, status, startDate, endDate, params)
}

function printNotes(token, type, status, startDate, endDate, params) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/nota/print/report/all/notes/or/per/model/?auth=${token}&type=${type}&idCliente=${params.idCliente || ''}&status=${status}&startDate=${startDate}&endDate=${endDate}`
  );
}
